import "data-layer-helper/dist/data-layer-helper";
import getWebAnalyticsContainer from "../datalayer/analytics-container";
import consentServiceHandler from "./consent";
import { triggerEvent } from "./event-registry";

const datalayer = getWebAnalyticsContainer();
let comoUpdateSent = false;
let pageViewSent = false;

observe(datalayer);

function observe(datalayer) {
	return new DataLayerHelper(datalayer, listener, true);
}

async function listener(model, message) {
	const { event } = message;

	// Spezielle Behandlung für como_update
	if (event === "como_update") {
		comoUpdateSent = true;
		if (pageViewSent) {
			consentServiceHandler(model);
		}
		return;
	}

	// Spezielle Behandlung für page_view
	if (event === "page_view") {
		triggerEvent("page_view", model, message);
		if (comoUpdateSent) {
			consentServiceHandler(model);
		} else {
			pageViewSent = true;
		}
		return;
	}

	// Alle anderen Events werden automatisch an registrierte Services weitergeleitet
	if (event) {
		triggerEvent(event, model, message);
	}
}
